const indexItems = [
  { label: '国产电视剧', count: '856部', icon: 'ri-tv-2-line', color: 'bg-primary-100 text-primary-600' },
  { label: '热门韩剧', count: '423部', icon: 'ri-heart-2-line', color: 'bg-accent-100 text-accent-600' },
  { label: '精选美剧', count: '312部', icon: 'ri-global-line', color: 'bg-secondary-100 text-secondary-700' },
  { label: '日剧动漫', count: '287部', icon: 'ri-ancient-gate-line', color: 'bg-primary-100 text-primary-600' },
  { label: '院线电影', count: '641部', icon: 'ri-film-line', color: 'bg-accent-100 text-accent-600' },
  { label: '网络电影', count: '438部', icon: 'ri-movie-line', color: 'bg-secondary-100 text-secondary-700' },
  { label: '综艺节目', count: '195部', icon: 'ri-live-line', color: 'bg-primary-100 text-primary-600' },
  { label: '纪录片', count: '162部', icon: 'ri-landscape-line', color: 'bg-accent-100 text-accent-600' },
];

export default function IndexSection() {
  return (
    <section id="index" className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">影视索引</h2>
          <p className="text-sm text-foreground-500">按类型快速找到你想看的内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl bg-background-50 border border-background-200 p-5 hover:border-primary-200 transition-colors cursor-pointer text-center"
            >
              <div className={`w-12 h-12 mx-auto rounded-xl flex items-center justify-center mb-3 ${item.color} group-hover:scale-110 transition-transform`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-medium text-foreground-900 mb-1">{item.label}</h3>
              <span className="text-xs text-foreground-400">{item.count}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}